export default "__VITE_ASSET__377bd21c__"